"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var constants_1 = require("../../constants");
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        startAdorment: {
            minHeight: function (props) { return props.textFieldHeight; },
            backgroundColor: '#F3F3F3',
            paddingRight: theme.spacing(1.5),
            borderRadius: '8px 0px 0px 8px',
            // borderRight: `1px solid ${theme.palette.divider}`,
            flexShrink: 0,
            marginRight: 30,
            textAlign: 'center',
        },
        startAdormentText: {
            minWidth: '87px',
            paddingLeft: theme.spacing(1.5),
            color: 'black',
            fontSize: '14px',
        },
    });
});
var FormStartAdorment = function (_a) {
    var children = _a.children;
    var classes = useStyles({
        textFieldHeight: constants_1.TEXT_FIELD_HEIGHT,
    });
    return (react_1.default.createElement(core_1.InputAdornment, { className: classes.startAdorment, position: "start" },
        react_1.default.createElement(core_1.Typography, { className: classes.startAdormentText, color: "textSecondary" }, children)));
};
exports.default = FormStartAdorment;
